import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";
import { getAppShellBackground } from "assets/themes/themeTokens";

export const getAppShellRootSx = (theme: Theme): SystemStyleObject<Theme> => ({
  minHeight: "100vh",
  background: getAppShellBackground(theme),
});

export const appShellOverlaySx = {
  position: "fixed",
  inset: 0,
  backgroundColor: "transparent",
  zIndex: (theme: Theme) => theme.zIndex.modal + 1,
  display: "none",
  pointerEvents: "none",
} as const;

export const appShellLoaderSx = {
  display: "none",
  zIndex: (theme: Theme) => theme.zIndex.modal + 2,
  left: "50%",
  top: "50%",
  position: "fixed",
  width: 50,
  aspectRatio: "1 / 1",
  borderRadius: "50%",
  border: (theme: Theme) => `8px solid ${theme.palette.info.light}`,
  borderRightColor: (theme: Theme) => theme.palette.primary.main,
  animation: "recon-shell-loader-spin 1s linear infinite",
  "@keyframes recon-shell-loader-spin": {
    to: {
      transform: "rotate(1turn)",
    },
  },
} as const;

interface AppShellMainOptions {
  topPadding?: number;
}

export const getAppShellMainSx = (sidebarWidth: number, options: AppShellMainOptions = {}) =>
  ({
    minHeight: "100vh",
    minWidth: 0,
    pt: options.topPadding ?? 10,
    px: { xs: 1.25, md: 2 },
    pb: 4,
    ml: `${sidebarWidth}px`,
    transition: "margin 200ms ease",
  }) as const;
